import Cookies from "universal-cookie";

const cookies = new Cookies(null, { path: "/" });

export function getLocalOrCookie(key: string) {
    let value = localStorage.getItem(key);
    return value ? value : cookies.get(key);
}
